import { Calendar } from "primereact/calendar";
import React, { useState, useEffect } from "react";
import "./CompareBuses.css";
import { Chart } from "primereact/chart";

import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { getBusesWOL } from "../../services/buses.services";
import {
  CommonDropdown,
  CommonInputField,
} from "../../components/common-input";
import moment from "moment";
import { getBusCompareData } from "../../services/compare.bus.service";
import { CommonGraph } from "../../components/graph";
import { getAgenciesWOL } from "../../services/agency.service";
import { agenciesSuccess } from "../../redux/agencies.slice";
import useToast from "../../context/toast.hook";
import { Toast } from "primereact/toast";
import { areDatesWithinOneYear } from "../../helpers/utils";
import {
  BUS_MANUFACTURERS,
  BUS_TECHNOLOGY,
} from "../../constants/constant.data";

const CompareBuses = () => {
  const [globalFilters, setGlobalFilters] = useState({
    propulsion: "",
    busSize: "",
  });
  const { errorToast, successToast, toastRef } = useToast();
  const dispatch = useDispatch();
  const { allAgencies } = useSelector((state) => state.agencies);
  const { currentUser } = useSelector((state) => state.user);
  const [allBuses, setAllBuses] = useState([]);
  const [dataFilter, setDataFilter] = useState("");
  const [filterCount, setFiltersCount] = useState([0, 1]);
  const [dateFilter, setDateFilter] = useState({
    fromDate: moment().subtract(6, "days").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  });
  const [graphData, setGraphData] = useState("");
  const [formattedDates, setFormattedDates] = useState("");

  const handleGetBusesWOL = () => {
    getBusesWOL()
      .then((res) => {
        setAllBuses(res.data?.data);
      })
      .catch((err) => {
        errorToast(err);
      });
  };

  const getAllAgencies = () => {
    getAgenciesWOL()
      .then((res) => {
        dispatch(agenciesSuccess(res?.data?.data));
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  useEffect(() => {
    handleGetBusesWOL();
    getAllAgencies();
  }, []);

  const removeAtIndex = (index) => {
    const newArray = filterCount.filter((item) => item !== index);
    const newDataFilter = { ...dataFilter };
    delete newDataFilter[index];
    setDataFilter(newDataFilter);
    setFiltersCount(newArray);
  };

  const addElement = () => {
    const newArray = [...filterCount, filterCount?.length + 1];
    setFiltersCount(newArray);
  };

  const handleApplyFilter = () => {
    getBusCompareData({ dateFilter, filters: dataFilter })
      .then((res) => {
        setGraphData(res?.data?.data);
        setFormattedDates(
          getFormattedDates(dateFilter?.fromDate, dateFilter?.toDate)
        );
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const handleApply = () => {
    let isFromDateGreater = !moment(dateFilter["toDate"]).isAfter(
      moment(dateFilter["fromDate"])
    );
    if (isFromDateGreater) {
      errorToast(false, "Date error", "From Date must be less than To Date");
      return;
    }

    if (
      areDatesWithinOneYear(
        dateFilter["fromDate"] || moment().format("YYYY-MM-DD"),
        dateFilter["toDate"] || moment().format("YYYY-MM-DD")
      )
    ) {
      errorToast(false, "Date error", "From and To date must be within 1 year");
      return;
    }

    handleApplyFilter();
  };

  const getPastDate = (key) => {
    setDateFilter({
      fromDate: moment().subtract(key, "days").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      key,
    });
  };

  function getFormattedDates(fromDate, toDate) {
    const start = moment(fromDate);
    const end = moment(toDate);
    const dates = [];

    while (start.isSameOrBefore(end, "day")) {
      dates.push(start.format("DD MMMM YYYY"));
      start.add(1, "day");
    }

    return dates;
  }

  const getgraphKey = (agencyId, busId) => {
    const agencyName = allAgencies?.find(
      (agency) => agency?._id === agencyId
    )?.name;
    const busName =
      busId === "all"
        ? "all"
        : allBuses?.find((bus) => bus?._id === busId)?.busNumberPlate;
    return `${agencyName} - ${busName}`;
  };

  const filterBusOnyears = (currentFilter, busArray) => {
    // Filter the bus array based on the serviceStartedAt year
    const filteredBuses = busArray.filter((bus) => {
      const agencyCheck = bus.agencyId === currentFilter.agencyId;
      const busManufacturerCheck =
        bus.busManufacturer?.toLowerCase() ===
        currentFilter.busManufacturer?.toLowerCase();
      const propulsion = globalFilters?.propulsion
        ? globalFilters?.propulsion === bus.technology
        : true;
      const busSize = globalFilters?.busSize
        ? parseInt(globalFilters?.busSize) === bus.busLength
        : true;
      return propulsion && busSize && agencyCheck && busManufacturerCheck;
    });

    return filteredBuses;
  };

  return (
    <>
      <h1>
        <strong>Compare Bus Data </strong>
      </h1>
      <Toast ref={toastRef} />
      <br />
      <br />
      <div className="mainSelect">
        <br />
        <div className="innerHeader align-items-center align-content-evenly">
          <div className="dateBox">
            <Calendar
              inputId="from_date"
              placeholder={moment().format("MM/DD/YYYY")}
              dateFormat={"mm/dd/yy"}
              value={
                dateFilter?.fromDate
                  ? moment(dateFilter?.fromDate).toDate()
                  : new Date()
              }
              maxDate={new Date()}
              onChange={(e) =>
                setDateFilter({
                  ...dateFilter,
                  fromDate: moment(e.value).format("YYYY-MM-DD"),
                  key: "",
                })
              }
              showIcon
              readOnlyInput
            />
          </div>
          <div className="dateBox">-</div>
          <div className="dateBox">
            <Calendar
              inputId="toDate_date"
              placeholder={moment().format("MM/DD/YYYY")}
              value={
                dateFilter?.toDate
                  ? moment(dateFilter?.toDate).toDate()
                  : new Date()
              }
              maxDate={new Date()}
              dateFormat={"mm/dd/yy"}
              onChange={(e) =>
                setDateFilter({
                  ...dateFilter,
                  toDate: moment(e.value).format("YYYY-MM-DD"),
                  key: "",
                })
              }
              showIcon
              readOnlyInput
            />
          </div>
          <div className="dateBox">
            <select
              name=""
              id="selectBus"
              className="selectBus"
              placeholder="Buses"
              style={{ width: "130px", height: "40px" }}
              onChange={(e) => getPastDate(e.target.value)}
              value={dateFilter?.key}
            >
              <option value="" disabled selected hidden>
                Select date
              </option>
              <option value="7">Last 1 week</option>
              <option value="14">Last 2 weeks</option>

              <option value="30">Last Month</option>
              <option value="365">Last Year</option>
            </select>
          </div>
          <div className="dateBox">
            <CommonDropdown
              placeholder="Propulsion"
              onChange={(e) =>
                setGlobalFilters({
                  ...globalFilters,
                  propulsion: e.target.value,
                })
              }
              isSelectAll
              value={globalFilters?.propulsion}
              optionArray={BUS_TECHNOLOGY}
              optionKey="key"
              optionLabel="key"
              style={{ height: "40px", width: "150px" }}
              label="Propulsion"
            />
          </div>
          <div className="dateBox">
            <CommonInputField
              name="busLength"
              placeholder="Bus Size (ft)"
              style={{
                height: "40px",
                marginTop: "0px",

                width: "150px",
              }}
              onChange={(e) => {
                setGlobalFilters({
                  ...globalFilters,
                  busSize: e.target.value,
                });
              }}
              type="number"
              keyfilter="int"
              min={1}
            />
          </div>
        </div>

        <hr />
        <br />
        <div className="selectAgent">
          {filterCount?.map((filter, index) => (
            <div className="selectAgentBox">
              <div className="selectBoxInner">
                <strong>
                  <span className="headingText">Select Agency</span>
                </strong>
              </div>
              <div className="selectBoxInner">
                <CommonDropdown
                  name="agencyId"
                  optionArray={allAgencies.filter(
                    (agency) => agency.role === "agency"
                  )}
                  optionKey="_id"
                  optionLabel="name"
                  placeholder="Select Agency"
                  label="Agency"
                  style={{ height: "40px" }}
                  value={
                    dataFilter &&
                    dataFilter[filter] &&
                    dataFilter[filter].agencyId
                  }
                  onChange={(e) => {
                    setDataFilter({
                      ...dataFilter,
                      [filter]: {
                        agencyId: e.target.value,
                        busId: "",
                        busManufacturer: "",
                      },
                    });
                  }}
                />
              </div>

              <div className="selectBoxInner">
                <CommonDropdown
                  name="busManufacturer"
                  optionArray={BUS_MANUFACTURERS}
                  optionKey="key"
                  optionLabel="label"
                  placeholder="Manufactured by"
                  label="Manufactured by"
                  value={
                    dataFilter &&
                    dataFilter[filter] &&
                    dataFilter[filter]?.busManufacturer
                  }
                  style={{ height: "40px" }}
                  onChange={(e) => {
                    setDataFilter({
                      ...dataFilter,
                      [filter]: {
                        ...dataFilter[filter],
                        busManufacturer: e.target.value,
                      },
                    });
                  }}
                />
              </div>

              <div className="selectBoxInner">
                <CommonDropdown
                  name="busId"
                  optionArray={
                    dataFilter &&
                    dataFilter[filter] &&
                    dataFilter[filter]?.busManufacturer &&
                    filterBusOnyears(dataFilter[filter], allBuses)
                  }
                  optionKey="_id"
                  optionLabel="busNumberPlate"
                  placeholder="Select Bus"
                  label="Bus"
                  value={
                    dataFilter && dataFilter[filter] && dataFilter[filter].busId
                  }
                  selectedAllValue="all"
                  isSelectAll
                  style={{ height: "40px" }}
                  onChange={(e) => {
                    if (
                      e.target.value !== "all" &&
                      Object.keys(dataFilter).find(
                        (md) => dataFilter[md].busId === e.target.value
                      )
                    ) {
                      errorToast(
                        false,
                        "Duplicate Filter",
                        "Bus already selected"
                      );
                      return;
                    }

                    setDataFilter({
                      ...dataFilter,
                      [filter]: {
                        ...dataFilter[filter],
                        busId: e.target.value,
                        key: getgraphKey(
                          dataFilter[filter]?.agencyId,
                          e.target.value
                        ),
                      },
                    });
                  }}
                />
              </div>

              {filterCount?.length > 1 && (
                <div className="selectBoxInnerDelete">
                  <Button
                    label="Remove"
                    severity="danger"
                    style={{
                      backgroundColor: "#F74A4A",
                      border: "0px",
                      width: "110px",
                    }}
                    onClick={() => removeAtIndex(filter)}
                  />
                </div>
              )}
            </div>
          ))}

          <div className="selectButtonBox">
            <Button
              label="Add more"
              icon="pi pi-plus"
              style={{ width: "130px", border: "0" }}
              onClick={addElement}
            />
            <Button
              onClick={handleApply}
              label="Apply"
              style={{ width: "130px", border: "0" }}
            />
          </div>
          <br />
        </div>
      </div>

      {graphData && Object.keys(graphData).length > 0 && (
        <>
          <CommonGraph
            formattedDates={formattedDates}
            graphData={graphData}
            title="Distance Travelled per Vehicle (km)"
            unit="km"
            graphKey="distanceTravelled"
          />

          <br />

          <CommonGraph
            formattedDates={formattedDates}
            graphData={graphData}
            title="kgH2"
            unit="kgH2"
            graphKey="energyUsed"
          />

          <br />
          <CommonGraph
            formattedDates={formattedDates}
            graphData={graphData}
            title="Average Energy Fuel Consumption Rate (km)"
            unit="kWh/km"
            graphKey="efficiency"
          />
          <br />
          <CommonGraph
            formattedDates={formattedDates}
            graphData={graphData}
            title="Relative Energy Cost (C$/km)"
            unit="C$/km"
            graphKey="energyCost"
          />

          {/* <br />
          <CommonGraph
            formattedDates={formattedDates}
            graphData={graphData}
            title="Avg failure distance (km)"
            unit="km"
            graphKey="avgFailureDistance"
          /> */}
        </>
      )}
    </>
  );
};

export default CompareBuses;
